import { useEffect, useRef } from 'react'

/** `visibilitychange` is the last reliable moment to write — `beforeunload`
 *  alone does not fire on mobile, which is exactly where this matters. */
export function useFlushOnHide(flush: () => void | Promise<void>): void {
  const latest = useRef(flush)
  latest.current = flush

  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === 'hidden') void latest.current()
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('pagehide', handler)
    return () => {
      document.removeEventListener('visibilitychange', handler)
      window.removeEventListener('pagehide', handler)
    }
  }, [])
}
